import { FinApiWebForm } from "@/components/shared/finapi/fin-api-web-form";
import { ErrorMessage } from "@/components/ui/error";
import { useParams, useSearch } from "@tanstack/react-router";

type Props = {
  onConfirm: () => void;
  onBack: () => void;
  webformId: string | null;
  invoiceIds: string[];
};

export const Payment = ({
  onConfirm,
  onBack,
  webformId,
  invoiceIds,
}: Props) => {
  const { company: companySlug } = useParams({ strict: false });
  const search = useSearch({ strict: false });

  if (!webformId) {
    return (
      <div className="flex-1 flex justify-center items-center h-full">
        <ErrorMessage />
      </div>
    );
  }

  const navigateBackTo = (search as { navigateBackTo?: string }).navigateBackTo;

  const baseRedirectUrl = `${window.location.origin}/${companySlug}/unternehmen/bezahlen`;

  const redirectParams = new URLSearchParams();

  redirectParams.set("invoiceIds", invoiceIds.join(","));
  if (navigateBackTo) {
    redirectParams.set("navigateBackTo", navigateBackTo);
  }

  const redirectUrl = encodeURIComponent(
    `${baseRedirectUrl}/fertig?${redirectParams.toString()}`,
  );
  const errorRedirectUrl = encodeURIComponent(
    `${baseRedirectUrl}/error?${redirectParams.toString()}`,
  );
  const abortRedirectUrl = encodeURIComponent(
    `${baseRedirectUrl}/error?${redirectParams.toString()}`,
  );

  return (
    <div>
      <FinApiWebForm
        id={webformId}
        targetUrl="https://webform-live.finapi.io"
        redirectUrl={redirectUrl}
        errorRedirectUrl={errorRedirectUrl}
        abortRedirectUrl={abortRedirectUrl}
      />
    </div>
  );
};
